import { getAuth } from 'firebase/auth';
import { app } from './firebase';

const DRAFT_URL =
  'https://us-central1-roamr-4f8ad.cloudfunctions.net/draftTourDescription';

/**
 * Gemini-drafted tour description from the organizer's structured form data.
 * Returns HTML paragraphs for the rich-text editor. The organizer edits before
 * saving — nothing is written server-side.
 */
const BRIEFING_URL =
  'https://us-central1-roamr-4f8ad.cloudfunctions.net/ensureRouteBriefing';

/**
 * Fetch (or lazily generate) the AI ride briefing for a published route.
 * Idempotent server-side — the briefing is cached on the route doc.
 */
export async function ensureRouteBriefing(routeId) {
  const res = await fetch(BRIEFING_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ routeId }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Server error ${res.status}`);
  return data.briefing;
}

export async function draftTourDescription(tour) {
  if (!app) throw new Error('Firebase not configured.');
  const user = getAuth(app).currentUser;
  if (!user) throw new Error('Must be signed in.');

  const idToken = await user.getIdToken();
  const res = await fetch(DRAFT_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
    body: JSON.stringify({ tour }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Server error ${res.status}`);
  return data.description;
}
